import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const HeaderCell = styled.th.withConfig({
  displayName: "FeatureTableHeaderCell__HeaderCell",
  componentId: "auq88r-0"
})(({
  theme
}) => ({
  textAlign: 'center',
  fontWeight: theme.typography['body-100'].fontWeight,
  position: 'relative',
  padding: `${theme.space['400']} ${theme.space['400']} ${theme.space['0']} ${theme.space['400']}`,
  verticalAlign: 'bottom'
}));
const ContentWrapper = styled.span.withConfig({
  displayName: "FeatureTableHeaderCell__ContentWrapper",
  componentId: "auq88r-1"
})({
  display: 'inline-flex',
  flexDirection: 'column',
  textAlign: 'center'
});
const FeatureTableHeaderCell = ({
  apiName,
  Content
}) => {
  return /*#__PURE__*/_jsx(HeaderCell, {
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      children: Content
    })
  }, `${apiName}-header-cell`);
};
export default FeatureTableHeaderCell;